<template>
	<section>
        <div class="form-pengiriman">
            <section name="step-1" v-show="step == 1">
                <div style="min-height: calc(100vh - 277px);">
                    <img src="/img/milestone-form-step-1.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                    <div class="text-center mt-4 col-lg-5 mx-auto">
                        <p class="f-16"><b>Pilih tipe pengiriman</b></p>
                        <div class="row mb-2">
                            <div class="col-md-6 mt-1">
                                <button @click="model.type = 1" id="loose" 
                                    class="w-100 btn p-0 active bg-white"
                                    style="
                                        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
                                        border: 1px solid #F0F0F0;
                                        border-radius:10px;
                                    ">
                                    <img src="/img/tipe-kg.png" alt="" class="mt-4">
                                    <p class="mt-4">Kg</p>
                                </button>
                            </div>
                            <div class="col-md-6 mt-1">
                                <button @click="model.type = 2" id="full" 
                                    class="w-100 btn p-0 bg-white"  
                                    style="
                                        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
                                        border: 1px solid #F0F0F0;
                                        border-radius:10px;
                                    ">
                                    <img src="/img/tipe-box.png" alt="" class="mt-4">
                                    <p class="mt-4">Box</p>
                                </button>
                            </div>
                        </div>
                        <p :class="model.type == 1 ? 'popup-left' : 'popup-right'" class="text-left">
                            {{ model.type == 1 ? 
                                'Pengiriman Berdasarkan Berat' : 
                                'Pengiriman Berdasarkan Jumlah Box'
                            }}
                        </p>
                        <div class="alert alert-info f-12 mt-2">
                            Jika Anda perlu pengiriman <i>Full Load</i>, silakan langsung kontak <i>Customer service</i> kami
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-primary f-14 mt-4" @click="step = step+1">Selanjutnya</button>
                </div>
            </section>
            <section name="step-2" v-show="step == 2">
                <ValidationObserver ref="step2">
				    <form @submit.prevent="set_step(3)">
                        <div style="min-height: calc(100vh - 277px);">
                            <img src="/img/milestone-form-step-2.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                            <p class="f-16"><b>Alamat Pickup</b></p>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Nama pengirim" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Pengirim</label>
                                            <vue-autosuggest
                                                v-model					= model.pengirim.name
                                                :suggestions			= suggestPelanggan
                                                :get-suggestion-value	= formattedDisplay
                                                :input-props			="{class: 'form-control', placeholder:'Masukkan nama pengirim', disabled: isDisabled.pengirim}"
                                                @input					= searchNamaPelanggan
                                                @selected="selectedAddress('pengirim', $event)">
                                                <template slot-scope="{suggestion}">
                                                    <div class="row pointer">
                                                        <span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.name}} <br>{{suggestion.item.phone_number}} </span>
                                                        <span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.address}} </span>
                                                    </div>								
                                                </template>
                                            </vue-autosuggest>
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="No. telepon pengirim" v-slot="{ errors }" rules="required|min:8|alpha_num">
                                        <div class="form-group">
                                            <label for="">No. Telepon</label>
                                            <input type="number" class="form-control" v-model="model.pengirim.phone_number" placeholder="Masukkan nomor telepon pengirim" :disabled="isDisabled.pengirim">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Provinsi pengirim" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Provinsi</label>
                                            <multiselect 
                                                open-direction="bottom"
                                                v-model="model.pengirim.province" 
                                                placeholder="Pilih Provinsi" 
                                                :options="locations.map(x => x.provinsi).reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]).sort()" 
                                                :multiple="false" 
                                                :disabled="isDisabled.pengirim" 
                                                @input="selectedCityPengirim = null, model.pengirim.id_city = '', model.pengirim.id_zipcode = '', $forceUpdate()"/>
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <ValidationProvider name="Kota / kabupaten pengirim" v-slot="{ errors }" rules="required">
                                                <div class="form-group">
                                                    <label for="">Kota / Kabupaten</label>
                                                    <multiselect 
                                                        open-direction="bottom"
                                                        v-model="selectedCityPengirim" 
                                                        placeholder="Pilih Kota / Kabupaten" 
                                                        track-by="id"
                                                        label="kabupaten"
                                                        :options="locations.filter(x => x.provinsi == model.pengirim.province)" 
                                                        :multiple="false" 
                                                        @input="model.pengirim.id_city = selectedCityPengirim.id, get_kode_pos('pengirim', model.pengirim.id_city)"
                                                        :disabled="isDisabled.pengirim"/>
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <ValidationProvider name="Kode pos pengirim" v-slot="{ errors }" rules="required">
                                                <div class="form-group">
                                                    <label for="">Kode Pos</label>
                                                    <select v-model="model.pengirim.id_zipcode" class="form-control" :disabled="isDisabled.pengirim">
                                                        <option value="">Pilih Kode Pos</option>
                                                        <option :value="zip_code.id" v-for="zip_code in zip_codes.pengirim" :key="zip_code.id">
                                                            {{zip_code.kodepos}}
                                                        </option>
                                                    </select>
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Alamat lengkap pengirim" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Alamat Lengkap</label>
                                            <input type="text" class="form-control" v-model="model.pengirim.address" placeholder="Masukkan alamat lengkap pengirim" :disabled="isDisabled.pengirim">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label mt-2">
                                            Kordinat lokasi (opsional) 
                                            <a data-toggle="modal" href="#pilihKordinatPengirim" class="link" v-if="!isDisabled.pengirim"> Pilih Kordinat</a>
                                        </label>								
                                        <GmapMap
                                            class = "maps mb-2"
                                            style = "height: 150px"
                                            :center = map.pengirim.center
                                            :options = map.options
                                            :zoom = map.pengirim.zoom
                                            @click="set_marker('pengirim', $event)">
                                            <gmap-marker
                                                v-for="(item, index) in map.pengirim.markers"
                                                :key="index"
                                                :position="item"/>
                                        </GmapMap>
                                        <p class="f-14">
                                            <b>{{ map.pengirim.address }} </b>
                                            <a href="javascript:;" class="link float-right" @click="delete_kordinat('pengirim')" v-if="model.pengirim.lat != '' && !isDisabled.pengirim">Hapus Kordinat</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <button type="button" class="btn text-warning f-14 mt-4 bg-white" @click="step = step-1">Kembali</button> &nbsp;
                            <button type="submit" class="btn btn-primary f-14 mt-4">Selanjutnya</button>
                        </div>
                    </form>
                </ValidationObserver>
            </section>
            <section name="step-3" v-show="step == 3">
                <ValidationObserver ref="step3">
				    <form @submit.prevent="set_step(4)">
                        <div style="min-height: calc(100vh - 277px);">
                            <img src="/img/milestone-form-step-3.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                            <p class="f-16"><b>Alamat Penerima</b></p>
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Nama penerima" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Penerima</label>
                                            <vue-autosuggest
                                                v-model					= model.penerima.name
                                                :suggestions			= suggestPelanggan
                                                :get-suggestion-value	= formattedDisplay
                                                :input-props			="{class: 'form-control', placeholder:'Masukkan nama penerima', disabled: isDisabled.penerima}"
                                                @input					= searchNamaPelanggan
                                                @selected="selectedAddress('penerima', $event)">
                                                <template slot-scope="{suggestion}">
                                                    <div class="row pointer">
                                                        <span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.name}} <br>{{suggestion.item.phone_number}} </span>
                                                        <span class="my-suggestion-item col m-0 align-self-center">{{suggestion.item.address}} </span>
                                                    </div>								
                                                </template>
                                            </vue-autosuggest>
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="No. telepon penerima" v-slot="{ errors }" rules="required|min:8|alpha_num">
                                        <div class="form-group">
                                            <label for="">No. Telepon</label>
                                            <input type="number" class="form-control" v-model="model.penerima.phone_number" placeholder="Masukkan nomor telepon penerima" :disabled="isDisabled.penerima">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Provinsi penerima" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Provinsi</label>
                                            <multiselect 
                                                open-direction="bottom"
                                                v-model="model.penerima.province" 
                                                placeholder="Pilih Provinsi" 
                                                :options="locations.map(x => x.provinsi).reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]).sort()" 
                                                :multiple="false" 
                                                :disabled="isDisabled.penerima" 
                                                @input="selectedCityPenerima = null, model.penerima.id_city = '', model.penerima.id_zipcode = '', $forceUpdate()"/>
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <ValidationProvider name="Kota / kabupaten penerima" v-slot="{ errors }" rules="required">
                                                <div class="form-group">
                                                    <label for="">Kota / Kabupaten</label>
                                                    <multiselect 
                                                        open-direction="bottom"
                                                        v-model="selectedCityPenerima" 
                                                        placeholder="Pilih Kota / Kabupaten" 
                                                        track-by="id"
                                                        label="kabupaten"
                                                        :options="locations.filter(x => x.provinsi == model.penerima.province)" 
                                                        :multiple="false" 
                                                        @input="model.penerima.id_city = selectedCityPenerima.id, get_kode_pos('penerima', model.penerima.id_city)"
                                                        :disabled="isDisabled.penerima"/>
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-12">
                                            <ValidationProvider name="Kode pos penerima" v-slot="{ errors }" rules="required">
                                                <div class="form-group">
                                                    <label for="">Kode Pos</label>
                                                    <select v-model="model.penerima.id_zipcode" class="form-control" :disabled="isDisabled.penerima">
                                                        <option value="">Pilih Kode Pos</option>
                                                        <option :value="zip_code.id" v-for="zip_code in zip_codes.penerima" :key="zip_code.id">
                                                            {{zip_code.kodepos}}
                                                        </option>
                                                    </select>
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <ValidationProvider name="Alamat lengkap penerima" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Alamat Lengkap</label>
                                            <input type="text" class="form-control" v-model="model.penerima.address" placeholder="Masukkan alamat lengkap penerima" :disabled="isDisabled.penerima">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                    <div class="form-group">
                                        <label class="form-label mt-2">
                                            Kordinat lokasi (opsional) 
                                            <a data-toggle="modal" href="#pilihKordinatPenerima" class="link" v-if="!isDisabled.penerima"> Pilih Kordinat</a>
                                        </label>								
                                        <GmapMap
                                            class = "maps mb-2"
                                            style = "height: 150px"
                                            :center = map.penerima.center
                                            :options = map.options
                                            :zoom = map.penerima.zoom
                                            @click="set_marker('penerima', $event)">
                                            <gmap-marker
                                                v-for="(item, index) in map.penerima.markers"
                                                :key="index"
                                                :position="item"/>
                                        </GmapMap>
                                        <p class="f-14">
                                            <b>{{ map.penerima.address }} </b>
                                            <a href="javascript:;" class="link float-right" @click="delete_kordinat('penerima')" v-if="model.penerima.lat != '' && !isDisabled.penerima">Hapus Kordinat</a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <button type="button" class="btn text-warning f-14 mt-4 bg-white" @click="step = step-1">Kembali</button> &nbsp;
                            <button type="submit" class="btn btn-primary f-14 mt-4">Selanjutnya</button>
                        </div>
                    </form>
                </ValidationObserver>
            </section>
            <section name="step-4" v-show="step == 4">
                <ValidationObserver ref="step4">
                    <form @submit.prevent="set_step(5)">
                        <div style="min-height: calc(100vh - 277px);">
                            <img src="/img/milestone-form-step-4.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                            <p class="f-16"><b>Detail Produk</b></p>
                            <div class="row" v-for="(product, index) in model.products" :key="index">
                                <div class="col-5">
                                    <ValidationProvider :name="'Nama produk ' + (index+1)" v-slot="{ errors }" rules="required">
                                        <div class="form-group">
                                            <label for="">Nama Produk</label>
                                            <input type="text" class="form-control" v-model="product.name" placeholder="Masukkan nama produk">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                                <div class="col-7">
                                    <div class="row row-cols-5">
                                        <div class="col">
                                            <ValidationProvider :name="'Panjang ' + (index+1)" v-slot="{ errors }" rules="required|alpha_num">
                                                <div class="form-group">
                                                    <label for="">Panjang</label>
                                                    <input type="number" class="form-control"  v-model="product.length" placeholder="1 Cm">
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col">
                                            <ValidationProvider :name="'Lebar ' + (index+1)" v-slot="{ errors }" rules="required|alpha_num">
                                                <div class="form-group">
                                                    <label for="">Lebar</label>
                                                    <input type="number" class="form-control"  v-model="product.width" placeholder="1 Cm">
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col">
                                            <ValidationProvider :name="'Tinggi ' + (index+1)" v-slot="{ errors }" rules="required|alpha_num">
                                                <div class="form-group">
                                                    <label for="">Tinggi</label>
                                                    <input type="number" class="form-control"  v-model="product.height" placeholder="1 Cm">
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col">
                                            <ValidationProvider :name="'Berat ' + (index+1)" v-slot="{ errors }" rules="required|alpha_num">
                                                <div class="form-group">
                                                    <label for="">Berat</label>
                                                    <input type="number" class="form-control"  v-model="product.weight" placeholder="1 Kg">
                                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col">
                                            <div class="form-group">
                                                <label for=""></label>
                                                <div class="text-center mt-2">
                                                    <button type="button" class="btn p-2 bg-white text-danger" @click="delete_product(index)" v-if="model.products.length > 1"><i class="fa fa-trash"></i></button>
                                                    <button type="button" class="btn p-2 bg-white text-warning" @click="add_product()" v-if="index == model.products.length-1"><i class="fa fa-plus"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <ValidationProvider name="Catatan" v-slot="{ errors }" rules="max:150">
                                        <div class="form-group">
                                            <label for="">Catatan (Opsional)</label>
                                            <input type="text" class="form-control" v-model="model.note" placeholder="Ex: Jangan dibanting">
                                            <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                        </div>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </div>
                        <div class="col text-center">
                            <button type="button" class="btn text-warning f-14 mt-4 bg-white" @click="step = step-1">Kembali</button> &nbsp;
                            <button type="submit" class="btn btn-primary f-14 mt-4">Selanjutnya</button>
                        </div>
                    </form>
                </ValidationObserver>
            </section>
            <section name="step-5" v-show="step == 5">
                <ValidationObserver ref="step5">
				    <form @submit.prevent="set_step(6)">
                        <div style="min-height: calc(100vh - 277px);">
                            <img src="/img/milestone-form-step-5.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                            <p class="f-16"><b>Kurir Pengiriman</b></p>
                            <hr style="border-style: dashed">
                            <ValidationProvider name="Kurir pengiriman" v-slot="{ errors }" rules="required">
                                <div class="form-group w-50">
                                    <label for="">Kurir Pengiriman</label>
                                    <select class="form-control" v-model="model.id_rute" @change="get_shipper_detail()">
                                        <option value="">Pilih Kurir</option>
                                        <option v-for="route in routes" :key="route.id" :value="route.id">
                                            {{ route.merchant.name }} - 
                                            <span v-if="model.type == 1">{{ set_price(route.price) | currency }}</span>
                                            <span v-else>{{ set_price(route.price_box) | currency }}</span>
                                        </option>
                                    </select>
                                    <small class="text-danger" v-if="errors[0]">{{ errors[0] }}</small>
                                </div>
                            </ValidationProvider>
                        </div>
                        <div class="col text-center">
                            <button type="button" class="btn text-warning f-14 mt-4 bg-white" @click="step = step-1">Kembali</button> &nbsp;
                            <button type="submit" class="btn btn-primary f-14 mt-4">Selanjutnya</button>
                        </div>
                    </form>
                </ValidationObserver>
            </section>
            <section name="step-6" v-show="step == 6">
                <div style="min-height: calc(100vh - 277px);">
                    <img src="/img/milestone-form-step-6.png" alt="" class="img-fluid pl-4 pr-4 mb-4">
                    <div class="row">
                        <div class="col-6" style="border-right: 1px solid #f0f0f0;">
                            <p class="f-16"><b>Informasi Produk</b></p>
                            <small>Catatan</small>
                            <p class="f-14"><i>{{ model.note == '' ? 'Tidak ada catatan' : model.note }}</i></p>
                            <hr style="border-style: dashed">
                            <div class="form-group" v-for="(product, index) in model.products" :key="index">
                                <label for="">Product {{index+1}}</label>
                                <div class="row">
                                    <div class="col f-14"><b>{{product.name}}</b></div>
                                    <div class="col text-right f-14"><b>{{product.weight}} Kg</b></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <p class="f-16"><b>Tipe Pengiriman</b></p>
                            <p class="f-16" v-if="model.type == 1">Kg <small>(Pengiriman Berdasarkan Berat)</small></p>
                            <p class="f-16" v-else>Box <small>(Pengiriman Berdasarkan Jumlah Box)</small></p>
                            <!-- <p class="f-16">Loose Load</p> -->
                            <hr style="border-style: dashed">
                            <p class="f-14"><b>Pickup Dari</b></p>
                            <div class="col">
                                <div class="row">
                                    <img src="/img/fa-solid_map-marker-alt.png" alt="" style="height: fit-content" class="mt-2 mr-2">
                                    <div class="col">
                                        <p class="mb-0 f-14"><b>{{ model.pengirim.name }} - {{ model.pengirim.phone_number }}</b></p>
                                        <p class="text-secondary mb-0 f-14">{{ model.pengirim.address }}</p>
                                    </div>
                                </div>
                            </div>
                            <hr style="border-style: dashed">
                            <p class="f-14"><b>Pengiriman Ke</b></p>
                            <div class="col">
                                <div class="row">
                                    <img src="/img/fa-solid_map-marker-alt-green.png" alt="" style="height: fit-content" class="mt-2 mr-2">
                                    <div class="col">
                                        <p class="mb-0 f-14"><b>{{ model.penerima.name }} - {{ model.penerima.phone_number }}</b></p>
                                        <p class="text-secondary mb-0 f-14">{{ model.penerima.address }}</p>
                                    </div>
                                </div>
                            </div>
                            <hr style="border-style: dashed">
                            <p class="f-14 mb-0"><b>{{ shipper.merchant.name }}</b></p>
                            <p class="f-14" v-if="model.type == 1">
                                {{ totalBerat }} Kg x {{ shipper.price | currency }} = {{ set_price(shipper.price) | currency }}
                            </p>
                            <p class="f-14" v-else>
                                {{ model.products.length }} Box x {{ shipper.price_box | currency }} = {{ set_price(shipper.price_box) | currency }}</p>
                        </div>
                    </div>
                </div>
                <div class="col text-center">
                    <button class="btn text-warning f-14 mt-4 bg-white" @click="step = step-1">Kembali</button> &nbsp;
                    <button class="btn btn-primary f-14 mt-4" @click="store()">Order</button>
                </div>
            </section>
        </div>

        <div class="modal fade" id="pilihKordinatPengirim">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>		                
						<gmap-autocomplete
                            @place_changed="set_kordinat('pengirim', $event)"
                            placeholder="Masukkan alamat"
                            class="form-control">
						</gmap-autocomplete>
						<GmapMap
                            class = "maps mb-2"
                            style = "height: 330px"
                            :center = map.pengirim.center
                            :options = map.options 
                            :zoom = map.pengirim.zoom							
                            @click="set_marker('pengirim', $event)">
							<gmap-marker
                                v-for="(item, index) in map.pengirim.markers"
                                :key="index"
                                :position="item"/>
						</GmapMap>
						<p class="f-14"><b>{{ map.pengirim.address }} </b></p>
                        <div class="text-right">
		                    <button type="button" class="btn btn-primary" data-dismiss="modal">Simpan</button>
                        </div>
		            </div>
		        </div>
		    </div>
		</div>
        <div class="modal fade" id="pilihKordinatPenerima">
		    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
		        <div class="modal-content mx-auto">                           
		            <div class="modal-body">                
		                <p class="f-14 f-m-12"><b>Pilih Kordinat</b>   
		                <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close">
		                    <span aria-hidden="true">&times;</span>
		                </button>
		                </p>
		                <div class="mt-2 f-14" style="background-color: #ffe8cf; border-radius: 4px; padding:20px 20px;">
		                    Pastikan lokasi yang kamu pilih tidak berbeda jauh dengan alamat yang kamu isi di kolom alamat.
		                </div>		                
						<gmap-autocomplete
                            @place_changed="set_kordinat('penerima', $event)"
                            placeholder="Masukkan alamat"
                            class="form-control">
						</gmap-autocomplete>
						<GmapMap
                            class = "maps mb-2"
                            style = "height: 330px"
                            :center = map.penerima.center
                            :options = map.options 
                            :zoom = map.penerima.zoom							
                            @click="set_marker('penerima', $event)">
							<gmap-marker
                                v-for="(item, index) in map.penerima.markers"
                                :key="index"
                                :position="item"/>
						</GmapMap>
						<p class="f-14"><b>{{ map.penerima.address }} </b></p>
		                <div class="text-right">
		                    <button type="button" class="btn btn-primary" data-dismiss="modal">Simpan</button>
                        </div>
		            </div>
		        </div>
		    </div>
		</div>
	</section>
</template>
<script>
import Vue from "vue"
export default {
	data() {
		return {
            step: 1,
            locations: [],
            routes: [],
            shipper: {
                merchant: {
                    name: ''
                }
            },
            zip_codes: {
                pengirim: [],
                penerima: []
            },
			map: {
                pengirim: {
                    address: '',
                    place: '',
                    markers: [],
                    lat: '',
                    lng: '',
                    zoom: 4,
                    center: { lat:-2.2145852388265177, lng:117.104081069627 }
                },
                penerima: {
                    address: '',
                    place: '',
                    markers: [],
                    lat: '',
                    lng: '',
                    zoom: 4,
                    center: { lat:-2.2145852388265177, lng:117.104081069627 }
                },
                options: {
                    streetViewControl: false,
                    fullscreenControl: false,
                    mapTypeControl: false,
                },
			},
            model: {
                id_rute: '',
                type: 1,
                note: '',
                pengirim: {
                    name: '',
                    phone_number: '',
                    province: '',
                    id_city: '',
                    id_zipcode: '',
                    address: '',
                    lat: '',
                    lng: ''
                },
                penerima: {
                    name: '',
                    phone_number: '',
                    province: '',
                    id_city: '',
                    id_zipcode: '',
                    address: '',
                    lat: '',
                    lng: ''
                },
                products: [
                    {
                        name: '',
                        length: '',
                        width: '',
                        height: '',
                        weight: '',
                    }
                ]
            },
            suggestPelanggan: [
				{
				    data: []
				}
			],
            isDisabled: {
                pengirim: false,
                penerima: false
            },
            selectedCityPengirim: null,
            selectedCityPenerima: null,
            totalBerat: 0
		}
	},
    methods: {
        get_location()
        {
			let _ = this
			_.axios.get('/location')
				.then(resp => {
                    _.locations = resp.data.data.rows
				}).catch(err => {
					console.log(err.response)
				})
		},
        get_kode_pos(type, id_city)
        {
			let _ = this			
			_.axios.get('/location?id=' + id_city )
				.then(resp => {
                    _.zip_codes[type] = resp.data.data.rows.kodepos
                    _.$forceUpdate()
				})
				.catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})			
		},
        set_kordinat(type, place)
        {
		    let _ = this
            let latLng = {
                lat: parseFloat(place.geometry.location.lat()),
                lng: parseFloat(place.geometry.location.lng()),
            }

            _.map[type].place 	= place
            _.map[type].markers = [latLng]
            _.map[type].center 	= latLng
            _.map[type].zoom 	= 18

            Vue.$geocoder.send(latLng,
                response => {
                    _.map[type].address = response.results[0].formatted_address
                })
            
            _.model[type].lat = parseFloat(place.geometry.location.lat())
            _.model[type].lng = parseFloat(place.geometry.location.lng())
            _.$forceUpdate()
		},
        delete_kordinat(type) {
            let _ 					= this
            _.map[type].markers 	= []
			_.map[type].address 	= ''
            _.map[type].zoom        = 4,
            _.map[type].center      = { lat:-2.2145852388265177, lng:117.104081069627 }
			_.model[type].lat		= ''
			_.model[type].lng		= ''
            _.$forceUpdate()
        },	
        set_marker(type, place) 
        {
		    let _ = this

			_.model[type].markers = [{
                lat: parseFloat(place.latLng.lat()),
                lng: parseFloat(place.latLng.lng()),
			}]

            Vue.$geocoder.send({
                lat: parseFloat(place.latLng.lat()),
                lng: parseFloat(place.latLng.lng()),
            },
            response => {
                _.map[type].address = response.results[0].formatted_address
            })
			
			_.model[type].lat = parseFloat(place.latLng.lat())
			_.model[type].lng = parseFloat(place.latLng.lng())
            _.$forceUpdate()
		},
        add_product()
        {
            let _ = this
            _.model.products.push({
                name: '',
                length: '',
                width: '',
                height: '',
                weight: '',
            })
        },
        delete_product(index)
        {
            let _ = this
            _.model.products.splice(index, 1)
        },
        get_routes()
        {
            let _ = this
            _.axios.get('/pricelist/customer' + 
                    '?id_origin=' + _.model.pengirim.id_city + 
                    '&id_destination=' + _.model.penerima.id_city)
                .then(resp => {
				    _.routes = resp.data.data.rows
                    if (_.routes.length > 0) { 
                        _.step += 1
                    } else {
                        this.$swal.fire({
                            title: 'Rute Belum Tersedia',
                            text: 'Rute ' + _.selectedCityPengirim.kabupaten +' ke '+ _.selectedCityPenerima.kabupaten +' belum tersedia. Silakan hubungi Customer Service kami',
                            icon: 'error',
                            confirmButtonColor: '#0036A0',
                            confirmButtonText: 'Hubungi Customer Service',
                            }).then((result) => {
                                if (result.value) {
                                    window.open('https://beta.bisacek.com/kontak/', '_blank');
                                }
                        })
                    }
                }).catch(err => {
                    this.$toast.open({
                        message: err.response.data.message,
                        type: "error"
                    })
                })
        },
        get_shipper_detail()
        {
            let _ = this
            _.shipper = _.routes.filter(x => x.id == _.model.id_rute)[0]
        },
        set_price(price)
        {
            let _ = this			

			if (_.model.type == 1){
                let berat_bersih 	= 0
                let berat_masa 		= 0
                let volume 			= 0
                
                _.model.products.map( function( value ) {
                    berat_bersih 	+= parseFloat( value.weight )
                    volume 			+= ( value.length * value.width * value.height ) / 1000000
                    berat_masa 		+= ( volume * 1000000 ) / 6000
                })

				if (berat_bersih > berat_masa){	
                    _.totalBerat = berat_bersih
					return berat_bersih * price
				} else{			
                    _.totalBerat = berat_masa
					return berat_masa * price
                }
			}
			else {
                return price * _.model.products.length
			}
        },
        store() 
        {
            let _ = this
            let data = {
                ..._.model,
                products: JSON.stringify(_.model.products),
                harga: _.model.type == 1 ? _.set_price(_.shipper.price) : _.set_price(_.shipper.price_box)
            }
            _.axios.post('/shipment/customer', data)
                .then( resp => {
                    if ( resp.data.status ) {
                        _.$router.push('/my-order')
                    }
                })
                .catch(err => {
					console.log(err.response)
				})
        },
        get_addresses()
        {
            let _ = this
            _.axios.get('/address')
                .then(resp => {
                    _.suggestPelanggan[0].data = resp.data.data
                })
        },
        formattedDisplay(result) {
		    return result.item.name
		},
        selectedAddress(type, result) {
		    let _ = this
			let item = result.item
            _.get_kode_pos(type, item.id_location)

            if (type == 'pengirim') {
                _.selectedCityPengirim = item.location
            } else {
                _.selectedCityPenerima = item.location
            }
            
            _.model[type].name = item.name
            _.model[type].phone_number = item.phone_number
            _.model[type].province = item.province
            _.model[type].id_city = item.id_location
            _.model[type].id_zipcode = item.id_kodepos
            _.model[type].address = item.address
            _.model[type].lat = item.lat
            _.model[type].lng = item.lng
            _.model[type].province = _.locations.filter(x => x.id == item.id_location).map( z => z.provinsi )[0]

            _.isDisabled[type] = true
			
			if(item.lat != null && item.lng != null){
				var latLng = {
					lat: parseFloat(item.lat),
					lng: parseFloat(item.lng)
				}

                _.map[type].markers = [latLng]
                _.map[type].center 	= latLng
                _.map[type].zoom 	= 18

                Vue.$geocoder.send(latLng,
                    response => {
                        _.map[type].address = response.results[0].formatted_address
                    })
			}
            _.$forceUpdate()
		},
        searchNamaPelanggan(input) {
		    let _ = this
			_.axios.get('/address?key=' + input).then(resp => {
                _.suggestPelanggan[0].data = resp.data.data
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
        async set_step( step ) {
            let _ = this

            if ( step == 3 ) {
                const isValid = await this.$refs.step2.validate();
                if (!isValid) { 
                    return;
                }
            } else if ( step == 4 ) {
                const isValid = await this.$refs.step3.validate();
                if (!isValid) { 
                    return;
                }
                _.get_routes()
                return;
            } else if ( step == 5 ) {
                const isValid = await this.$refs.step4.validate();
                if (!isValid) { 
                    return;
                }
            } else if ( step == 6 ) {
                const isValid = await this.$refs.step5.validate();
                if (!isValid) { 
                    return;
                }
            }

            _.step = step
        }
    },
	mounted(){
		var loose = '#loose';
		var full = '#full';

		$(loose).on('click', function(){
			$(full).removeClass('active');
			$(loose).addClass('active');			
		});

		$(full).on('click', function(){
			$(loose).removeClass('active');
			$(full).addClass('active');
		});

        let _ = this
        _.get_location()
        _.get_addresses()
	}
}
</script>